<template>
  <el-dialog :visible.sync="dialogVisible" @close="close" width="500px" :close-on-click-modal="false">
    <div class="kefu">
        <el-image :src="serviceQRCode ? serviceQRCode : '../../../assets/img/kefu_code.jpeg'" class="lxfs">
            <div slot="error">
                <img class="lxfs" src="../../../assets/img/kefu_code.jpeg" />
            </div>
        </el-image>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "",
  props: {},
  components: {},
  data() {
    return {
      dialogVisible: true,
      serviceQRCode: localStorage.getItem('serviceQRCode'),
    };
  },
  mounted() {
    
  },
  methods: {
    
    close(){
        this.$emit('close')
    }
  },
};
</script>

<style lang="scss" scoped>
.kefu{
    display: flex;
    justify-content: center;
}
</style>
